import Crud from '../views/Vehicle/Crud'
import Entity from '../views/Vehicle/Add'

let routes = {
    path: '/vehicles',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/vehicles/add',
            name: 'NewVehicle',
            component: Entity,
            meta: {
                pageTitle: 'Veículo',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Veículo',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicles/edit/:id?',
            name: 'EditVehicle',
            component: Entity,
            meta: {
                pageTitle: 'Veículo',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Veículo',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicles',
            name: 'list-vehicles',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Veículos',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Veículos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
